import React, { useEffect } from 'react'
import { animate, motion, useMotionValue } from 'framer-motion'

/** 沿路径移动的能量光点，停在当前关外缘，不使用形象头像。 */
export default function QuestEnergyOrb({
  pathD,
  ratio = 0,
  fromRatio = null,
  travel = false,
  reduceMotion = false,
  point,
}) {
  const clamped = Math.max(0, Math.min(1, ratio))
  const distance = useMotionValue(`${clamped * 100}%`)
  const supportsOffset = typeof CSS !== 'undefined'
    && CSS.supports?.('offset-path', 'path("M 0 0 L 10 10")')

  useEffect(() => {
    const next = `${clamped * 100}%`
    if (!supportsOffset || !pathD) return undefined
    if (reduceMotion || !travel) {
      distance.set(next)
      return undefined
    }
    const start = `${Math.max(0, Math.min(1, fromRatio ?? clamped)) * 100}%`
    distance.set(start)
    const controls = animate(distance, next, { duration: 0.9, ease: 'easeInOut' })
    return () => controls.stop()
  }, [clamped, fromRatio, travel, reduceMotion, supportsOffset, pathD, distance])

  const core = (
    <span className={`quest-orb-core${reduceMotion ? '' : ' is-live'}`} aria-hidden="true">
      <span className="quest-orb-tail" />
      <span className="quest-orb-dot" />
      {travel && !reduceMotion ? <span className="quest-orb-burst" /> : null}
    </span>
  )

  if (supportsOffset && pathD) {
    return (
      <motion.div
        className="quest-orb"
        style={{ offsetPath: `path("${pathD}")`, offsetDistance: distance, offsetRotate: '0deg' }}
        aria-hidden="true"
      >
        {core}
      </motion.div>
    )
  }

  return (
    <motion.div
      className="quest-orb is-pinned"
      animate={{ left: point?.x || 0, top: (point?.y || 0) - 36 }}
      transition={reduceMotion || !travel ? { duration: 0 } : { duration: 0.9 }}
      aria-hidden="true"
    >
      {core}
    </motion.div>
  )
}
